module.exports = __webpack_public_path__ + "assets/img/index-intro-xs-03@2x.483cd84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/index-intro-xs-03@2x.png
// module id = 906
// module chunks = 1